import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import SensitiveCommunitiesReducer, {
    defaultState, asyncActions,
} from 'src/ducks/sensitive-communities.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
    return useReducerHook(SensitiveCommunitiesReducer, defaultState, asyncActions);
};

type IFSensitiveCommunitiesContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const SensitiveCommunitiesContext = createContext<Partial<IFSensitiveCommunitiesContext>>({
    state: defaultState,
}) as React.Context<IFSensitiveCommunitiesContext>;

const SensitiveCommunitiesProvider: React.FC = ({ children }) => {
    const reducer = useReducer();

    return (
        <SensitiveCommunitiesContext.Provider value={{ ...reducer }}>
            {children}
        </SensitiveCommunitiesContext.Provider>
    );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useSensitiveCommunitiesContext = () => useContext(SensitiveCommunitiesContext);

export type IuseSensitiveCommunitiesContext = ReturnType<typeof useSensitiveCommunitiesContext>;

export { SensitiveCommunitiesContext, SensitiveCommunitiesProvider };
